export const enum EAlertMessageType {
  Info = 1,
  Warning = 2,
  Danger = 3,
}



// WEBPACK FOOTER //
// ./src/app/core/enums/message.enum.ts